import {commonPromise} from '@/http'
//用户相关接口

let userInfoUrl = '/app/api/token/info'; // 获取用户信息
let modifyInfoUrl = '/app/api/user/modifyInfo';  // 用户信息修改
let uploadImageUrl = '/app/api/file/uploadImage';  // 上传图片
let addChildUserUrl = '/app/api/user/addChildUser';  // 添加下级用户

export const getUserInfoFetch = (data) => commonPromise(data, userInfoUrl, 'GET','',false);
export const modifyInfoFetch = (data) => commonPromise(data, modifyInfoUrl, 'post');
export const uploadImageFetch = (data) => commonPromise(data, uploadImageUrl, 'post','form');
export const addChildUserFetch = (data) => commonPromise(data, addChildUserUrl, 'post');


// WEBPACK FOOTER //
// ./src/api/userApi.js